var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { jsx } from "react/jsx-runtime";
import React__default from "react";
import "../../Utilities.js";
import { VirtualizedComboBox, ComboBox as ComboBox$1 } from "@fluentui/react/lib/ComboBox";
import { ReadOnlyField } from "../ReadOnly/ReadOnlyField.js";
import "../Label/index.js";
import { getValues } from "../ReadOnly/readOnly.utils.js";
import { getId, css } from "@fluentui/utilities";
import { Label } from "../Label/Label.js";
const defaultClassName = "ane-ComboBox ane-ComboBox";
const defaultRootClassName = "ane-ComboBox-container";
const ComboBoxStyles = {
  root: defaultRootClassName,
  optionsContainerWrapper: { maxHeight: "500px" },
  rootDisabled: { backgroundColor: "#f3f2f1", borderWidth: "1px", borderColor: "#aaa8a7" }
};
class ComboBox extends React__default.Component {
  constructor(props) {
    super(props);
    __publicField(this, "_id", "");
    __publicField(this, "comboBoxRef", null);
    __publicField(this, "_onRenderLabel", (comboBoxLabelProps) => {
      if (!comboBoxLabelProps) {
        return null;
      }
      const { props } = comboBoxLabelProps;
      const { id = this._id, required = false, disabled = false, label = "" } = props;
      const { labelProps } = this.props;
      const labelId = `${id}-label`;
      if (!label) {
        return null;
      }
      return /* @__PURE__ */ jsx(Label, __spreadProps(__spreadValues({}, labelProps), { htmlFor: `${id}-component`, id: labelId, required, disabled, children: label }));
    });
    this._id = props.id || getId("ComboBox");
    this.comboBoxRef = React__default.createRef();
    this.state = {
      options: this.props.options
    };
  }
  componentDidUpdate(prevProps) {
    if (prevProps.options !== this.props.options) {
      this.setState({ options: this.props.options });
    }
  }
  render() {
    const _a = this.props, {
      className,
      id = this._id,
      required = false,
      disabled = false,
      label = "",
      labelProps,
      virtualized = false,
      selectedKey,
      isReadOnly,
      options,
      styles,
      openOnClick = true,
      autofill,
      onInputValueChange
    } = _a, rest = __objRest(_a, [
      "className",
      "id",
      "required",
      "disabled",
      "label",
      "labelProps",
      "virtualized",
      "selectedKey",
      "isReadOnly",
      "options",
      "styles",
      "openOnClick",
      "autofill",
      "onInputValueChange"
    ]);
    const comboBoxOptionStyles = __spreadValues({
      optionText: [
        "ane-Combobox-option",
        {
          overflow: "visible",
          whiteSpace: "normal"
        }
      ]
    }, this.props.comboBoxOptionStyles);
    const values = getValues(selectedKey, options, "text");
    const openMenu = () => {
      var _a2;
      return (_a2 = this.comboBoxRef.current) == null ? void 0 : _a2.focus(true);
    };
    const conditionalOpenMenu = () => {
      if (openOnClick) {
        openMenu();
      }
    };
    const filterOptions = (option) => {
      openMenu();
      const filteredOptions = options.filter((opt) => opt.text.toLowerCase().includes(option.toLowerCase()));
      this.setState({ options: filteredOptions });
    };
    const _onAutoFillClick = (ev) => {
      if (!!(autofill == null ? void 0 : autofill.onClick))
        autofill == null ? void 0 : autofill.onClick(ev);
      if (!ev.defaultPrevented)
        conditionalOpenMenu();
    };
    return !!isReadOnly ? /* @__PURE__ */ jsx(ReadOnlyField, { id, label, value: values }) : /* @__PURE__ */ jsx(React__default.Fragment, { children: !!virtualized ? /* @__PURE__ */ jsx(
      VirtualizedComboBox,
      __spreadProps(__spreadValues({}, rest), {
        label,
        onRenderLabel: this._onRenderLabel,
        required,
        options: this.state.options,
        comboBoxOptionStyles,
        selectedKey,
        className: css(defaultClassName, className, "virtualized"),
        disabled,
        id,
        styles: __spreadValues(__spreadValues({}, ComboBoxStyles), styles),
        componentRef: this.comboBoxRef,
        onInputValueChange: onInputValueChange || filterOptions,
        autofill: __spreadProps(__spreadValues({}, this.props.autofill), {
          onClick: _onAutoFillClick
        })
      })
    ) : /* @__PURE__ */ jsx(
      ComboBox$1,
      __spreadProps(__spreadValues({}, rest), {
        label,
        onRenderLabel: this._onRenderLabel,
        required,
        options: this.state.options,
        comboBoxOptionStyles,
        selectedKey,
        className: css(defaultClassName, className),
        disabled,
        id,
        styles: __spreadValues(__spreadValues({}, ComboBoxStyles), styles),
        componentRef: this.comboBoxRef,
        onInputValueChange: onInputValueChange || filterOptions,
        autofill: __spreadProps(__spreadValues({}, this.props.autofill), {
          onClick: _onAutoFillClick
        })
      })
    ) });
  }
}
export {
  ComboBox,
  ComboBox as default
};
//# sourceMappingURL=ComboBox.js.map
